import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { useLanguage } from '../../context/LanguageContext';

const TermsOfServiceDialog = ({ open, onClose, isDarkMode }) => {
  const { language, t } = useLanguage();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: isDarkMode ? '#1e1e1e' : '#fff',
        }
      }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>
        {language === 'ge' ? 'მომსახურების პირობები' : language === 'ru' ? 'Условия использования' : 'Terms of Service'}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {language === 'ge' ? 'ეფექტური თარიღი: 09.07.2024' : language === 'ru' ? 'Дата вступления: 09.07.2024' : 'Effective Date: 09.07.2024'}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 1 }}>
          {/* Georgian Content */}
          {language === 'ge' && (
            <>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>1. პირობების მიღება</Typography>
              <Typography variant="body2" paragraph>
                ჩვენს ვებ-გვერდზე ან სერვისებზე წვდომით თქვენ ეთანხმებით მომსახურების პირობებს. თუ არ ეთანხმებით, გთხოვთ, არ გამოიყენოთ ვებ-გვერდი.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>2. სერვისების გამოყენება</Typography>
              <Typography variant="body2" paragraph>
                სერვისები გამოიყენეთ მხოლოდ კანონიერი მიზნებისთვის. აკრძალულია ვებ-გვერდის უსაფრთხოების დარღვევა ან სხვისი უფლებების შელახვა.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>3. მომხმარებლის პასუხისმგებლობა</Typography>
              <Typography variant="body2" paragraph>
                თქვენ ხართ პასუხისმგებელი ნებისმიერ ინფორმაციაზე, რომელსაც გვიგზავნით საკონტაქტო ფორმით. თქვენ ადასტურებთ, რომ ინფორმაცია არის ზუსტი და არ არღვევს მესამე მხარის უფლებებს.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>4. ინტელექტუალური საკუთხრება</Typography>
              <Typography variant="body2" paragraph>
                ამ საიტზე არსებული შინაარსი, დიზაინი, ტექსტები, გრაფიკა და კოდი წარმოადგენს ITFORSEC.COM-ის საკუთხრებას ან გამოიყენება შესაბამისი ლიცენზიით.
              </Typography>
              <Typography variant="body2" paragraph>
                ჩვენ პატივს ვცემთ სხვის ინტელექტუალურ საკუთხრებას. მესამე მხარის შინაარსი (ღია კოდის ხელსაწყოები, ფოტოები) რჩება მათი მფლობელების საკუთხრებში.
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>აკრძალულია შინაარსის კოპირება ან გავრცელება წერილობითი ნებართვის გარეშე</li>
                <li>აკრძალულია მესამე მხარის შინაარსის გამოყენება მათი ლიცენზიის დარღვევით</li>
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>5. კლიენტის შინაარსი</Typography>
              <Typography variant="body2" paragraph>
                პროექტები შეიძლება მოიცავდეს კლიენტის მიერ მოწოდებულ მასალებს (ლოგოები, ტექსტები). ITFORSEC.COM არ არის პასუხისმგებელი ამ მასალების მფლობელობის გადამოწმებაზე.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>6. პასუხისმგებლობის შეზღუდვა</Typography>
              <Typography variant="body2" paragraph>
                ITFORSEC.COM არ არის პასუხისმგებელი ნებისმიერ ირიბ ან შემთხვევით ზიანზე, რომელიც გამოწვეულია ვებ-გვერდის ან სერვისების გამოყენებით.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>7. ცვლილებები</Typography>
              <Typography variant="body2" paragraph>
                ჩვენ ვიტოვებთ უფლებას განვაახლოთ პირობები ნებისმიერ დროს. ცვლილებები ძალაში შედის გამოქვეყნებისთანავე.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>8. მოქმედი კანონმდებლობა</Typography>
              <Typography variant="body2" paragraph>
                ეს პირობები რეგულირდება საქართველოს კანონმდებლობით. ნებისმიერი დავა განიხილება საქართველოს სასამართლოების მიერ.
              </Typography>

              <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>დაგვიკავშირდით</Typography>
                <Typography variant="body2">
                  კითხვების შემთხვევაში მოგვწერეთ: <strong>info@itforsec.com</strong>
                </Typography>
              </Box>
            </>
          )}

          {/* Russian Content */}
          {language === 'ru' && (
            <>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>1. Принятие условий</Typography>
              <Typography variant="body2" paragraph>
                Доступаясь к нашему веб-сайту или используя наши услуги, вы соглашаетесь соблюдать эти Условия использования. Если вы не согласны, пожалуйста, не используйте наш веб-сайт.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>2. Использование услуг</Typography>
              <Typography variant="body2" paragraph>
                Вы соглашаетесь использовать наши услуги только в законных целях. Вам запрещено нарушать или пытаться нарушить безопасность веб-сайта или использовать его для нарушения прав других.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>3. Ответственность пользователя</Typography>
              <Typography variant="body2" paragraph>
                Вы несете ответственность за любую информацию, которую вы отправляете через наши контактные формы или услуги. Вы подтверждаете, что предоставляемая вами информация точна, актуальна и не нарушает законы или права третьих лиц.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>4. Интеллектуальная собственность</Typography>
              <Typography variant="body2" paragraph>
                Контент, дизайн и функциональность этого сайта, включая текст, графику, логотипы и код, являются собственностью ITFORSEC.COM или используются с соответствующего разрешения или лицензии третьих лиц.
              </Typography>
              <Typography variant="body2" paragraph>
                Мы уважаем права интеллектуальной собственности других. Любой контент третьих лиц (такой как инструменты с открытым исходным кодом, стоковые материалы или материалы, предоставленные клиентами) остается собственностью соответствующих владельцев.
              </Typography>
              <Typography variant="body2" paragraph>
                Пользователи не могут:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>Копировать, воспроизводить или распространять проприетарный контент без письменного разрешения</li>
                <li>Использовать контент третьих лиц с нарушением его лицензии</li>
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>5. Контент клиентов</Typography>
              <Typography variant="body2" paragraph>
                Некоторые проекты могут включать контент, предоставленный клиентами (например, логотипы, тексты, код). ITFORSEC.COM не несет ответственности за проверку права собственности на такой контент. Клиенты несут полную ответственность за обеспечение законных прав на все предоставленные материалы.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>6. Ограничение ответственности</Typography>
              <Typography variant="body2" paragraph>
                ITFORSEC.COM не несет ответственности за любые косвенные, случайные или последующие убытки, возникающие в результате использования вами веб-сайта или услуг.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>7. Изменения</Typography>
              <Typography variant="body2" paragraph>
                Мы оставляем за собой право обновлять или изменять эти Условия использования в любое время. Изменения вступают в силу немедленно после публикации. Продолжение использования веб-сайта после внесения изменений означает ваше согласие с пересмотренными условиями.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>8. Применимое право</Typography>
              <Typography variant="body2" paragraph>
                Данные условия регулируются и толкуются в соответствии с законодательством Грузии. Любые споры подлежат исключительной юрисдикции судов Грузии.
              </Typography>

              <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Свяжитесь с нами</Typography>
                <Typography variant="body2" paragraph>
                  Если у вас есть вопросы об этих Условиях использования, пожалуйста, свяжитесь с нами:<br/>
                  • Email: info@itforsec.com<br/>
                  • Website: https://itforsec.com
                </Typography>
              </Box>
            </>
          )}

          {/* English Content (Default) */}
          {language === 'en' && (
            <>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>1. Acceptance of Terms</Typography>
              <Typography variant="body2" paragraph>
                By accessing or using our website and services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our website.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>2. Use of Services</Typography>
              <Typography variant="body2" paragraph>
                You agree to use our services for lawful purposes only. You are prohibited from violating or attempting to violate the security of the website or using it to infringe upon the rights of others.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>3. User Responsibilities</Typography>
              <Typography variant="body2" paragraph>
                You are responsible for any information you submit through our contact forms or services. You agree that the information you provide is accurate, current, and does not violate any laws or third-party rights.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>4. Intellectual Property</Typography>
              <Typography variant="body2" paragraph>
                The content, design, and functionality on this site, including text, graphics, logos, and code, are either the property of ITFORSEC.COM or used with appropriate permission or licensing from third parties.
              </Typography>
              <Typography variant="body2" paragraph>
                We respect the intellectual property rights of others. Any third-party content (such as open-source tools, stock media, or client-provided materials) remains the property of its respective owner.
              </Typography>
              <Typography variant="body2" paragraph>
                Users may not:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>Copy, reproduce, or distribute proprietary content without written permission</li>
                <li>Use third-party content in violation of its respective license</li>
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>5. Client Content</Typography>
              <Typography variant="body2" paragraph>
                Some projects may include content submitted by clients (e.g., logos, copy, code). ITFORSEC.COM is not responsible for verifying the ownership of such content. Clients are solely responsible for ensuring they have legal rights to all submitted material.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>6. Limitation of Liability</Typography>
              <Typography variant="body2" paragraph>
                ITFORSEC.COM shall not be liable for any indirect, incidental, or consequential damages arising from your use of the website or services.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>7. Modifications</Typography>
              <Typography variant="body2" paragraph>
                We reserve the right to update or change these Terms of Service at any time. Changes will be effective immediately upon posting. Continued use of the website after changes constitutes your acceptance of the revised terms.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>8. Governing Law</Typography>
              <Typography variant="body2" paragraph>
                These terms are governed by and construed in accordance with the laws of Georgia. Any disputes shall be subject to the exclusive jurisdiction of the courts in Georgia.
              </Typography>

              <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Contact Us</Typography>
                <Typography variant="body2" paragraph>
                  If you have any questions about these Terms of Service, please contact us at:<br/>
                  • Email: info@itforsec.com<br/>
                  • Website: https://itforsec.com
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary" sx={{ borderRadius: 2 }}>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsOfServiceDialog;
